import shopCard from "./shopCard"
export default shopCard;
